// extracted by mini-css-extract-plugin
export default {"Table":"Table_Table__XZLQZ","Th":"Table_Th__A4ANX","Row":"Table_Row__FDqOy","Td":"Table_Td__P72Lk"};